import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './pages/Home';
import Ticket from './pages/Ticket';
import NotFound from './pages/NotFound';
function App() {
  
  return (
    <BrowserRouter>
      <Routes>
        
        <Route path='/' element={<Home />} />
        <Route path='/buy-ticket' element={<Ticket />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
